export default __webpack_public_path__ + "static/media/logo_slim_parts.f6f23aaa.png";